import { Text, View } from '@react-pdf/renderer';
import { dateFormat } from "helpers/common";

export const ClassroomDetailsPdf = ({ styles, data }) => {
  return (
    <>
      <View>
        <Text style={styles.subHeading}>SCHOOL</Text>
        <Text style={{ ...styles.fontLight, fontSize: 14, marginTop: "2px" }}>{data?.schoolName}</Text>
      </View>
      {/* <View>
          <Text style={styles.subHeading}>LAST NAME</Text>
          <Text style={{ fontSize: 16, ...styles.fontLight, marginTop: "2px" }}>{data?.lastname}</Text>
      </View> */}
      <View style={{ justifyContent: "space-between" }}>
          <Text style={styles.subHeading}>CITY/TOWN</Text>
          <Text style={styles.para2}>{data?.schoolLocation}</Text>
      </View>
      <View style={{ justifyContent: "space-between" }}>
          <Text style={styles.subHeading}>CLASS NAME</Text>
          <Text style={styles.para}>{data?.report_classname}</Text>
      </View>
      <View style={{ justifyContent: "space-between" }}>
          <Text style={styles.subHeading}># OF STUDENTS</Text>
          <Text style={styles.para}>{data?.report_total_students}</Text>
      </View>
      <View style={{ justifyContent: "space-between" }}>
          <Text style={styles.subHeading}>GRADE</Text>
          <Text style={styles.para}>{data?.report_grade}</Text>
      </View>
      <View style={{ justifyContent: "space-between" }}>
          <Text style={styles.subHeading}>AGE RANGE</Text>
          <Text style={styles.para}>{data?.report_age_range}</Text>
      </View>
    </>
  )
}